(() => {
  function initialize(root = document) {
    root.querySelectorAll('video.mq-viewport-video').forEach(video => {
      if (video.dataset.mqVideoReady) return;
      video.dataset.mqVideoReady = 'true';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const activate = () => {
        let changed = false;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          changed = true;
        });
        if (changed) video.load();
        if (!motion.matches && !navigator.connection?.saveData) video.play().catch(() => {});
      };
      if (!('IntersectionObserver' in window)) { activate(); return; }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) activate(); else video.pause(); });
      }, { threshold: .15 });
      observer.observe(video);
      video.addEventListener('pointerdown', activate, { once: true });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(video)) observer.disconnect();
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
